import React, { useState, useEffect } from 'react';
import Box from '../../Box';
import Toast from '../../Toast';
import Tools from '../../Tools';
import ModalWindow from '../../ModalWindow';
import { ReactComponent as CloseIcon } from '../../icons/close.svg';
import MoreMenu from '../../ui/moreMenu/MoreMenu';
import { useSoftphone } from '../../SoftphoneContext.jsx';


const TaskTreeClaroDicom = (props) => {

    const [contactTypes, setContactTypes] = useState([]);
    const [taskTypes, setTaskTypes] = useState([]); 
    const [actionCodes, setActionCodes] = useState([]); 
    const [error, setError] = useState(false);
    const [toastRef, setToastRef] = useState(React.createRef()); 
    const [client, setClient] = useState(null); 
    const [taskFields, setTaskFields] = useState([]); 
    const [currentCompanyId, setCurrentCompanyId] = useState(null);
    const [showListofTaskTypes, setShowListofTaskTypes] = useState(false);
    const [allFieldsFilled, setAllFieldsFilled] = useState(false);
    const [loadingTaskTypes, setLoadingTaskTypes] = useState(false);
    const [loadingTaskFields, setLoadingTaskFields] = useState(false);
    const [lockAfterSave, setLockAfterSave] = useState(false);
    const [showTipTerminateCall, setShowTipTerminateCall] = useState(false);
    const [blockedByCurrentCall, setBlockedByCurrentCall] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null); 
    const [showPreviewImage, setShowPreviewImage] = useState(false); 
    const [imageKey, setImageKey] = useState(new Date().valueOf()); 
    const [datos, setDatos] = useState({ contactType: 0, taskType: 0, actionCode:''}); 
    const { incomingCallStatus } = useSoftphone();

    useEffect(() => {
        setCurrentCompanyId(props.campaign.companyId);
        setClient(props.client);

        //contactTypes
        fetch(`${process.env.REACT_APP_URI_API_CRM}/contactTypes?idCompany=${props.campaign.companyId}`)
        .then(res => res.json())
        .then(
            (result) => {
                setContactTypes(result);
            },
            (error) => {
                setError(error);
            }
        )


        //GENERIC LISTS
        //getMapList(1,'motivosNoPago');
        
        //custom list for action codes
        setActionCodes([
            {code:'LC', desc:'Celular'},
            {code:'LH', desc:'Particular'},
            {code:'LL', desc:'Comercial'},
            {code:'LO', desc:'Otro'},
            {code: 'LI', desc:'Llamado Inbound'}
        ]);


    }, [props.client]);


    useEffect(() => { //VALIDATE TASKTREE
        let allFieldsFilled=true;
        taskFields.forEach(field => {
            if (field.required && (datos[field.name] === undefined || datos[field.name]==='')){
                allFieldsFilled = false;
            }

            //validacion especifica campos
            let refField = document.getElementsByName(field.name);
            if (refField[0]) {
                if(!refField[0].validity.valueMissing && !refField[0].validity.valid){
                    refField[0].classList.add('invalid');
                    allFieldsFilled = false;
                } else {
                    refField[0].classList.remove('invalid');
                }
            } 
        });
        
        setAllFieldsFilled(allFieldsFilled);
    }, [datos, taskFields]);

    useEffect(() => { //HACK TO CLEAN TASKTYPE AND VALIDATE TASKTREE
        setDatos({ ...datos, ['taskType']: 0 });
    }, [datos.contactType]);


    useEffect(() => {
        if (incomingCallStatus === 'ended' || incomingCallStatus === 'none' || incomingCallStatus === 'failed'){
            setShowTipTerminateCall(false);
        }

        //bloqueo boton guardar gestion si llamada aun no se contesta
        //if(props.campaign.type === "PROGRESSIVE" && (incomingCallStatus !== 'confirmed' && incomingCallStatus !== 'ended' && incomingCallStatus !== 'none' && incomingCallStatus !== 'failed')){
        if((props.campaign.type === "PROGRESSIVE" && (incomingCallStatus !== 'confirmed' && incomingCallStatus !== 'ended' && incomingCallStatus !== 'failed')) ||
            props.campaign.type === "PROGRESSIVE" && incomingCallStatus === 'none'){
           setBlockedByCurrentCall(true); 
        } else{
           setBlockedByCurrentCall(false);
        }
       

    }, [incomingCallStatus]);



    const handleInputChange = (event) => {
        setDatos({ ...datos, [event.target.name]: event.target.value })
    }

    const handleCalendar = (dateValue, fieldName) => {
        setDatos({ ...datos, [fieldName]: dateValue.toISOString() })
    }

    const getTaskTypesForContactType = (event) => {
        handleInputChange(event);
        getTaskTypes(event.target.value);
        setTaskFields([]);
    }

    const getTaskFieldsForTaskTypes = (event) => {
        handleInputChange(event);
        getTaskFields(event.target.value);
    }

    const getTaskTypes = (contactType) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        setShowListofTaskTypes(false);
        setLoadingTaskTypes(true);
        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/taskTypes`);
        url.search = new URLSearchParams({
            contactTypeId: contactType,
        });

        fetch(url, {
            method: 'GET',
            contentType: 'application/json',
            headers: { 'Authorization': currentSessionData.token }
        })
        .then(res => res.json())
        .then(
            (result) => {
                setTaskTypes(result);
                setShowListofTaskTypes(true);
                setLoadingTaskTypes(false);
            },
            (error) => {
                console.log('Se produjo un errrooooor:', error);
                setError(error);
                setShowListofTaskTypes(false);
                setLoadingTaskTypes(false);
            }
        )
    }


    const getTaskFields = (taskTypeId) => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        setLoadingTaskFields(true);
        let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/taskFields`);
        url.search = new URLSearchParams({
            taskTypeId: taskTypeId,
        });

        fetch(url, {
            method: 'GET',
            contentType: 'application/json',
            headers: { 'Authorization': currentSessionData.token }
        })
        .then(res => res.json())
        .then(
            (result) => {
                setTaskFields(result);
                setLoadingTaskFields(false);
            },
            (error) => {
                console.log('Se produjo un errrooooor:', error);
                setError(error);
                setLoadingTaskFields(false);
            }
        )
    }

    const saveTask = (nextUserStatus=null) => {
        //event.preventDefault();

        console.log('🐞DEBUG nextUserStatus1:', nextUserStatus);

        if (incomingCallStatus !== 'ended' && incomingCallStatus !== 'none' && incomingCallStatus !== 'failed'){
            setShowTipTerminateCall(true);
        } else {
            setShowTipTerminateCall(false);
            setLockAfterSave(true); //bloquea botón

            let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));

            let data = {
                clientObjectId: props.client._id,
                companyId: props.campaign.companyId,
                companyCode: props.campaign.company_info.code,
                campaignId: props.campaign._id,
                clientId: client.clientId,
                phone: props.client.currentPhone,
                contactType: datos.contactType,
                taskType: datos.taskType,
                observation: datos.observation
            };
            
            if (props.campaign.companyId === 107 || props.campaign.companyId === 108 || props.campaign.companyId === 109){
                data.actionCode = datos.actionCode;

                //get/set action desc
                let actionSearch=actionCodes.find((action) => action.code === datos.actionCode);
                data.actionDesc = actionSearch ? actionSearch.desc:'';   
            }

            let jsonTaskFields = [];
            taskFields.forEach(field => {
                let jsonField={};
                jsonField.name=field.name;
                jsonField.value = datos[field.name];
                jsonField.type = field.type;
                jsonTaskFields.push(jsonField);
            });

            data.taskFields = JSON.stringify(jsonTaskFields);


            //★★★★IMPORTANTE★★★
            //si hay grabacion de audio recupera los datos de la ultima grabacion
            //para verificar si corresponde a esta misma gestion
            //si es asi, entonces incluye un parámetro en los datos de la gestión
            //para que incorpore el dato de la URL

            if(props.lastRecordingData){
                if (props.lastRecordingData.campaignId === props.campaign._id && props.lastRecordingData.clientId === client.clientId){
                    data.hasAudioRecord=true;
                }
            }


            //console.log('🐞DEBUG JSON.stringify(data):',data);

            let url = new URL(`${process.env.REACT_APP_URI_API_CRM}/tasks`);
            fetch(url, {
                method: 'POST',
                contentType: 'application/json',
                headers: { 'Authorization': currentSessionData.token, Accept: 'application/json', 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            })
            .then(res => res.json())
            .then(
                (result) => {
                    setDatos({ contactType: 0, taskType: 0, actionCode: '' });
                    document.getElementById('formTask').reset();

                    //refresh taskList
                    //props.callbackAfterSaveTask();

                    toastRef.current.addToast('Una nueva gestión ha sido registrada', 5000);

                    //notify change user status to parent

                    console.log('🐞DEBUG nextUserStatus 2:', nextUserStatus);

                    if (nextUserStatus){
                        props.setUserStatus(nextUserStatus);

                        
                        //NO VA ESTO SI NO LO siguiente:
                        // si está ingresando gestion no debe poder entrar en pausa 



                    } else {
                        props.setUserStatus({ paused: false, code: 'ACTIVE', desc: 'Disponible' });
                    }
                    props.callbackAfterSaveTask();

                    setTaskFields([]);

                    setLockAfterSave(false); //DESBLOQUEA botón


                    if (props.lastRecordingData) {
                        if (props.lastRecordingData.campaignId === props.campaign._id && props.lastRecordingData.clientId === client.clientId) {
                            props.setLastRecordingData(null); 
                        }
                    }
                },
                (error) => {
                    console.log('Se produjo un errrooooor:', error);
                    setError(error);
                }
            )
        }
    }

    const getFileImage=(event)=>{
        const objectUrl = URL.createObjectURL(event.target.files[0])
        setSelectedImage(objectUrl)

        let targetName = event.target.name;
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = () => {
            setDatos({ ...datos, [targetName]: reader.result });
        }
    }

    const resetImage=(event, fieldName)=>{
       setSelectedImage(null);
       setImageKey(new Date().valueOf()); 
       setDatos({ ...datos, [fieldName]: undefined });
    }




    return (
        <form id="formTask" noValidate>
            <Toast ref={toastRef}></Toast>

            {showTipTerminateCall?(
                <div className="mustTerminateCallIndicator">Debe finalizar la llamada para poder ingresar la gestión</div>
            ):null}

            
            {showPreviewImage?(
                <ModalWindow closeMethod={() => setShowPreviewImage(!showPreviewImage)}>
                    <img className='bigPreview' src={selectedImage}/>
                </ModalWindow>
            ) : null}


            <h4 className="sectionTitle">ARBOL DE GESTIÓN</h4>
            <div className="flexRow">
                <div className="flexCol">

                    <Box type="select" name="actionCode" label="Tipo llamada" className="x2" placeholder="Seleccione ..." options={actionCodes} onChange={handleInputChange} required></Box>

                    <Box type="select" name="contactType" label="Tipo gestión" className="x2" placeholder="Seleccione ..." options={contactTypes} onChange={getTaskTypesForContactType} required></Box>
                    
                    {showListofTaskTypes ? ( //hack to re-create select for force to reset
                        <Box type="select" name="taskType" label="Causal de mora" className={loadingTaskFields ? 'x4 loading' : 'x4'} placeholder="Seleccione ..." options={taskTypes} onChange={getTaskFieldsForTaskTypes} required></Box>
                    ) : 
                        <Box className={loadingTaskTypes ? 'x4 loading' : 'x4'} type="readOnly" label="Causal de mora" value="Seleccione ..."/>
                    }

                    {taskFields.map((field, index) => {
                        switch (field.type) {
                            case 'TXT':
                                return (<Box key={index} type="text" name={field.name} label={field.desc} className="x5" placeholder="Ingrese ..." onChange={handleInputChange} required={field.required}></Box>)
                                break;
                            case 'AMM':
                                return (<Box key={index} type="number" name={field.name} className="x2" label={'$ ' + field.desc} placeholder="Ingrese monto" onChange={handleInputChange} required={field.required} max={field.max?props.max:(Number(props.debt)+1)}></Box>) //regla para monto maximo deuda
                                break;
                            case 'NUM':
                                return (<Box key={index} type="number" name={field.name} className="x2" label={field.desc} placeholder="Ingrese" onChange={handleInputChange} required={field.required}></Box>)
                                break;
                            case 'DATE':
                                //return (<Box key={index} type="calendar" name={field.name} className="x2" label={field.desc} selectedDate={datos.commitmentDate} onChange={handleCalendar} required></Box>)
                                return (<Box key={index} type="calendar" name={field.name} className="x2" label={field.desc} selectedDate={datos.commitmentDate} onChange={(e) => handleCalendar(e, field.name)} limitDaysAfter={field.limitDaysAfter} required={field.required}></Box>)
                                break;
                            case 'LIST':
                                return (<Box key={index} type="select" name={field.name} className="x2" label={field.desc} placeholder="Seleccione ..." genericListCode={field.list_code} companyId={currentCompanyId} onChange={handleInputChange} required={field.required}></Box>)
                                break;
                            case 'IMG':
                                return (
                                    <Box type="content" label="Imagen respaldo" className="x4 fileInput img" required={field.required}>
                                        <div>
                                            <input key={imageKey} name={field.name} type="file" onChange={getFileImage} accept="image/*" />
                                            {selectedImage ? (
                                                <div className="deleteImage">
                                                    <a className='close' onClick={(e) => resetImage(e, field.name)}><CloseIcon/></a>
                                                    <img className='preview' src={selectedImage} onClick={() => setShowPreviewImage(!showPreviewImage)}/>
                                                </div>
                                            ) : null}
                                        </div>
                                    </Box>
                                )
                                break;
                        }
                    })}  

                    <Box type="text" name="observation" label="Observación" className="x5" placeholder="Ingrese observación..." onChange={handleInputChange}></Box>           

                </div>
            </div>

            {Tools.clientIsBlocked(client)? (
                <p className='clientDisclaimer'>*Usuario bloqueado, no se permite registrar gestión de ejecutivos.</p>
            ) : null}

            {props.campaign.type === "PROGRESSIVE" && incomingCallStatus === 'none' ?(
                <p className='clientDisclaimer'>*Bloqueo por llamada no disponible.</p>
            ):null}

            <div className="flexRow">
                <div className="flexCol">
                    {/* <p>datos:{JSON.stringify(datos)}</p>
                    <p>taskFields:{JSON.stringify(taskFields)}</p>
                    <p>allFielsFilled: {allFieldsFilled.toString()}</p> */}
                    {/* <button className={(datos.contactType === 0 || datos.taskType === 0 || datos.actionCode === '' || !allFieldsFilled || lockAfterSave || Tools.clientIsBlocked(client) || blockedByCurrentCall) ? 'default disabled' : 'default'} type="button" onClick={() => saveTask()}>Guardar gestión</button> */}
                    {/* <button  type="button" onClick={() => saveTask()}>XxXXXXX</button>  */}
                
                
                    
                        <div className="bottonDropdown">
                        <button className={(datos.contactType === 0 || datos.taskType === 0 || datos.actionCode === '' || !allFieldsFilled || lockAfterSave || Tools.clientIsBlocked(client) || blockedByCurrentCall) ? 'default dropdown left disabled' : 'default dropdown left'} type="button" onClick={() => saveTask()}>Guardar gestión</button>
                        <button className={(datos.contactType === 0 || datos.taskType === 0 || datos.actionCode === '' || !allFieldsFilled || lockAfterSave || Tools.clientIsBlocked(client) || blockedByCurrentCall) ? 'default dropdown end disabled' : 'default dropdown end'} type="button">
                                <MoreMenu title="GUARDAR GESTIÓN y entrar en pausa" menuList={
                                    [
                                        {
                                            title: <span><i className='status paused'></i><i className='statusIcon ADM' />ADMINISTRATIVO</span>,
                                            action: () => { saveTask({ paused: true, code: 'ADM', desc: 'Administrativo' }); },
                                            visible: true
                                        },
                                        {
                                            title: <span><i className='status paused'></i><i className='statusIcon ALM' />ALMUERZO</span>,
                                            action: () => { saveTask({ paused: true, code: 'ALM', desc: 'Almuerzo' }); },
                                            visible: true
                                        },
                                        {
                                            title: <span><i className='status paused'></i><i className='statusIcon BK' />BREAK</span>,
                                            action: () => { saveTask({ paused: true, code: 'BK', desc: 'Break' }); },
                                            visible: true
                                        },
                                        {
                                            title: <span><i className='status paused'></i><i className='statusIcon BN' />BAÑO</span>,
                                            action: () => { saveTask({ paused: true, code: 'BN', desc: 'Baño' }); },
                                            visible: true
                                        },
                                        {
                                            title: <span><i className='status paused'></i><i className='statusIcon CP' />CAPACITACIÓN</span>,
                                            action: () => { saveTask({ paused: true, code: 'CP', desc: 'Capacitación' }); },
                                            visible: true
                                        },
                                        {
                                            title: <span><i className='status paused'></i><i className='statusIcon REU' />REUNIÓN</span>,
                                            action: () => { saveTask({ paused: true, code: 'REU', desc: 'Reunión' }); },
                                            visible: true
                                        },

                                    ]
                                } />
                            </button>
                        </div>
                    




                
                </div>
            </div>



            {/* <p>LR:{JSON.stringify(props.lastRecordingData)}</p> */}
            {/* <p>datos:{JSON.stringify(datos)}</p> */}


            {/* <p>showTipTerminateCall :{JSON.stringify(showTipTerminateCall)}</p>
            <p>incomingCallStatus :{JSON.stringify(incomingCallStatus)}</p>

            
            <p>props.campaign :{JSON.stringify(props.campaign)}</p> */}
            
            

            {/* {props.campaign.type === "PROGRESSIVE" && (incomingCallStatus !== 'confirmed' && incomingCallStatus !== 'ended' && incomingCallStatus !== 'none' && incomingCallStatus !== 'failed')?(
                <h1>BLOQUEAR BOTON?</h1>
            ):null} */}

            {/* solo para estos estados debiera dejarlo ingresar gestion
            incomingCallStatus==="confirmed"
            incomingCallStatus==="ended"

           Ver porqué no funciona esa condicion que dice "debe terminar la conversacion para poder ingresar gestion"

           */}

        
            
            {/* <h1>incomingCallStatus :{JSON.stringify(incomingCallStatus)}</h1> */}
        </form>
        
    );

}

export default TaskTreeClaroDicom;





